import { motion, useInView } from "framer-motion";
import TowerImage from "../../assets/homepage/TowerImage.png";
import { useRef } from "react";
import Button from "../button";
import DefaultSpacing from "../../utilities/constants";

const HomeAboutUsSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { amount: 0.5, once: true });

  const yAxisFadeAnimation = {
    hidden: {
      opacity: 0,
      y: 60,
      transition: {
        duration: 0.4,
        delay: 0.0,
        ease: "linear",
      },
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.4,
        delay: 0.8,
        ease: "linear",
      },
    },
  };

  const xAxisFadeAnimation = {
    hidden: {
      opacity: 0,
      x: 60,
      transition: {
        duration: 0.4,
        delay: 0.0,
        ease: "linear",
      },
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.4,
        delay: 0.2,
        ease: "linear",
      },
    },
  };

  const defaultSpacing = new DefaultSpacing();
  const gap = defaultSpacing.getDefaultGap();

  return (
    <>
      <div
        ref={ref}
        className={`grid grid-cols-1 place-items-center lg:grid-cols-2 ${gap}`}
      >
        <div className="col-span-2 h-full w-full overflow-hidden lg:col-span-1">
          <motion.img
            variants={yAxisFadeAnimation}
            initial={"hidden"}
            animate={isInView ? "visible" : "hidden"}
            src={TowerImage}
            alt=""
            className="aspect-auto h-full w-full rounded-sm 2xl:aspect-video"
          />
        </div>
        <div className="col-span-2 flex h-full flex-col justify-center lg:col-span-1">
          <motion.div
            variants={xAxisFadeAnimation}
            initial={"hidden"}
            animate={isInView ? "visible" : "hidden"}
            className="space-y-5"
          >
            <p className="text-lg font-normal text-black opacity-70">
              WHO WE ARE
            </p>
            <h1 className="text-3xl font-semibold text-visBlue">About Us</h1>
            <p className="text-lg font-normal leading-[1.625rem]">
              Welcome to Vis Group, your trusted partner for cutting-edge
              solutions in network benchmarking, infotainment system testing,
              software development, and quality assurance. With our global
              presence spanning Germany, Europe, the Middle East, and the UK, we
              empower businesses worldwide with unparalleled expertise and
              innovation. Unleash your potential with Vis Group and unlock
              limitless possibilities in the digital realm. <br /> <br />
              Vis Group elevates digital products worldwide through
              comprehensive testing solutions. Trust our expertise for flawless
              performance and exceptional user experience.
            </p>

            <Button href={"/aboutus"} origin={"origin-left"}>
              <span className="px-10">More About Us</span>
            </Button>
          </motion.div>
        </div>
      </div>
    </>
  );
};
export default HomeAboutUsSection;
